// @flow

import { useContext } from 'react';
import { Context, FlagContextType } from '../contexts/flagContext';

const useFlagContext: () => FlagContextType = () => useContext(Context);
export default useFlagContext;
